<div class="top-left-counter-card">
  <div ng-show="linkCounter.valuationPortfolio" class="counterItem">
    <span class="linkCount" ng-show="linkCounter.valuationPortfolio">{{ linkCounter.valuationPortfolio}} </span>
    <span class="linkLabel" ng-show="linkCounter.valuationPortfolio != 0">{{ 'projectValuation.valuationPortfolios' | translate | uppercase}}</span>
  </div>
  <div ng-show="linkCounter.report" class="counterItem">
    <span class="linkCount" ng-show="linkCounter.report != 0">{{ linkCounter.report}}</span>
    <span class="linkLabel" ng-show=" linkCounter.report != 0">{{ 'projectValuation.reports' | translate | uppercase}}</span>
  </div>
  <div ng-show="linkCounter.property" class="counterItem">
    <span class="linkCount" ng-show="linkCounter.property != 0">{{ linkCounter.property}}</span>
    <span class="linkLabel" ng-show=" linkCounter.property != 0">{{ 'projectValuation.properties' | translate | uppercase}}</span>
  </div>
</div>
